module.exports = __webpack_public_path__ + "img/empty-notification.dd1317ae.svg";